module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_troendelag_neg.59706327.pdf";